import { useTranslate } from '@ur-solutions/react-hooks'
import { DriverActivityType } from './consts'

/**
 * Translated display names per activity type, keyed by the raw
 * `activityType` value the API returns.
 */
export const useActivityTypeLabels = (): Record<string, string> => {
  const translations = useTranslate({
    work: 'common.work',
    available: 'common.availability',
    paidPause: 'common.paid-pause',
    driving: 'common.driving',
    pause: 'common.pause',
  })

  return {
    [DriverActivityType.WORK]: translations.work,
    [DriverActivityType.AVAILABLE]: translations.available,
    [DriverActivityType.PAID_REST]: translations.paidPause,
    [DriverActivityType.DRIVE]: translations.driving,
    [DriverActivityType.REST]: translations.pause,
  }
}
